'use client'

import { SolidGoogle } from '@qr-front/icons/solid-google'
import { cn } from '@qr-front/ui/utils'
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google'
import { useTranslations } from 'next-intl'

import { env } from '@/utils'

import { socialButtonStyle } from './shared'

type GoogleBtnProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onSubmit: (data: any) => void
	variant?: 'icon' | 'text'
	className?: string
	labelClassName?: string
}
export const GoogleAuthButton = (props: GoogleBtnProps) => {
	return (
		<GoogleOAuthProvider clientId={env.GOOGLE_AUTH_CLIENT_ID}>
			<GoogleButtonInternal {...props} />
		</GoogleOAuthProvider>
	)
}

const GoogleButtonInternal = ({
	onSubmit,
	variant = 'icon',
	className,
	labelClassName,
}: GoogleBtnProps) => {
	const t = useTranslations()

	const login = useGoogleLogin({
		onSuccess: (tokenResponse: { access_token: string }) => {
			onSubmit(tokenResponse?.access_token)
		},
		onError: (e) => console.log('Login Failed', e),
	})

	return (
		<button
			type="button"
			onClick={() => login()}
			className={cn(socialButtonStyle, className)}
		>
			<SolidGoogle className="shrink-0" />
			{variant === 'text' && (
				<span className={labelClassName}>
					{t('auth__signup__social_google')}
				</span>
			)}
		</button>
	)
}
